<!-- src/layouts/BlankLayout.vue -->
<template>
  <RouterView />
</template>
